import { Routes } from '@angular/router';
import { WidgetLayout } from './core/layouts/widget-layout/widget-layout';

export const routes: Routes = [
  {
    path: '',
    component: WidgetLayout,
    children: [
      { path: '', pathMatch: 'full', redirectTo: 'widget' },
      {
        path: 'widget',
        loadComponent: () => import('./pages/widget/widget').then((module) => module.PublicWidget),
      },
    ],
  },
  { path: '**', redirectTo: 'widget' },
];
